<template>
  <div class="home-div">
    <SideBar style="z-index: 9999" />
    <div class="top-title">
      <span class="type-text" ref="typeTextEl" :data-text="currentText"></span>
      <span class="cursor">|</span>
    </div>
    <div class="content">
      <div class="right">
        <div v-if="!showExtraPanelInPC" class="mobile-collapse-btn" @click="showExtraPanel = !showExtraPanel">
          {{
            showExtraPanel
              ? "收起 DataView 数据看板 ↑"
              : "展开 DataView 数据看板 ↓"
          }}
        </div>

        <div class="extra-panel" :class="{ open: showExtraPanel }">
          <div class="tag-container mbl">
            <div class="tag-icon-con">
              <img class="tag-icon" src="@/assets/icon/typeIcon.png" />标签
              <div class="tag-style"></div>
            </div>
            <div class="ls-line"></div>
            <div class="tag-list">
              <div v-for="(tag, index) in tags" :key="index" class="tag" :style="{ backgroundColor: getRandomColor() }"
                @click="searchListByKeyword(tag.id, 'typeId')">
                {{ tag.name }}&nbsp;{{ tag.count }}
              </div>
            </div>
          </div>
          <div>
            <div>
              <div class="rg-title-1">
                Dragon Raja: Something For Nothing.
              </div>
            </div>
            <div style="width: 100%; margin-bottom: 0 !important">
              <TimesView class="mbl font-color-1" />
            </div>
          </div>

          <div class="ls-div mbl font-color-1">
            <div style="display: flex; align-items: center; justify-items: center">
              <div class="ls-title">Month Archives 月览</div>
              <div class="tag-style"></div>
            </div>
            <div class="ls-line"></div>
            <div>
              <el-select v-model="lifeTime" placeholder="请选择" @change="handleToSelectItem">
                <el-option v-for="item in archivesList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <div class="month-list">
                <ul class="infinite-list">
                  <li v-for="item in titleList" :key="item" @click="searchListByKeyword(item, 'title')"
                    style="cursor: pointer" class="li-title">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="ls-div mbl font-color-1">
            <div style="display: flex; align-items: center; justify-items: center">
              <div class="ls-title">Recent Messages 留言</div>
              <div class="tag-style"></div>
            </div>
            <div class="ls-line"></div>
            <div>
              <div>
                <ul class="infinite-list">
                  <li v-for="item in currCommentList" :key="item.id"
                    @click="searchListByKeyword(item.lifeName, 'title')" style="cursor: pointer" class="li-title">
                    {{ item.name }} {{ item.relation }}-> {{ item.lifeName }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="left">
        <div class="announcement">
          <div class="book-icon-con">
            <img class="book-icon" src="@/assets/icon/book.png" />
            <div>{{ sysConfig.websiteDesc }}</div>
          </div>
        </div>

        <div v-if="lifeList.length === 0 && firstLoading" class="art-skeleton">
          <div class="skeleton-container">
            <div v-for="n in 6" :key="n" class="skeleton-card" :style="{ animationDelay: `${n * 0.1}s` }">
              <div class="skeleton-image"></div>
              <div class="skeleton-info">
                <div class="skeleton-line"></div>
                <div class="skeleton-line short"></div>
                <div class="skeleton-line small"></div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="info slide-in-left">
          <div class="md-div" v-for="item in lifeList" :key="item.id" :data-index="item.id"
            @click="goToDetail(item.id)">
            <!-- 第一行：图片 -->
            <div class="md-img-info">
              <div class="progressive-layer">
                <div v-if="item.lqip" class="image-blur-bg" :style="{ backgroundImage: `url(${item.lqip})` }"></div>

                <div v-if="item.mediaType === 'video'" style="position: relative; width: 100%; height: 100%">
                  <video :src="item.mediaUrl" style="width: 100%; height: 100%; object-fit: cover" preload="metadata"
                    muted loop></video>
                  <div style="
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      width: 60px;
                      height: 60px;
                      background: rgba(0, 0, 0, 0.6);
                      border-radius: 50%;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    ">
                    <div style="
                        width: 0;
                        height: 0;
                        border-left: 22px solid #fff;
                        border-top: 14px solid transparent;
                        border-bottom: 14px solid transparent;
                        margin-left: 6px;
                      "></div>
                  </div>
                </div>

                <img v-else-if="item.mediaType === 'image'" :data-src="item.mediaUrl" :alt="item.title"
                  class="photo-image" :class="{ loaded: item.imageLoaded }" decoding="async" />

                <img v-else :data-src="defaultCover" alt="默认封面" class="photo-image"
                  :class="{ loaded: item.imageLoaded }" decoding="async" />

                <div v-if="!item.imageLoaded" class="loading-state">
                  <div class="loading-circle">
                    <div class="loading-inner"></div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 第二行：标题 -->
            <div class="md-title">{{ item.title }}</div>

            <!-- 第三行：作者等信息 -->
            <div class="con-info">
              <div class="md-img-div">
                <div class="md-img-item">
                  <img class="md-img" src="@/assets/icon/icon-2.png" />{{
                    item.userName
                  }}
                </div>
                <div class="md-img-item">
                  <img class="md-img" src="@/assets/icon/icon-1.png" />{{
                    displayDate(item.createdTime)
                  }}
                </div>
                <div class="md-img-item">
                  <img class="md-img" src="@/assets/icon/icon-y.png" />{{
                    item.typeName
                  }}
                </div>
              </div>
              <div class="md-img-item">{{ item.temp }}°C</div>
            </div>

            <div class="card-line"></div>
            <!-- 第四行：摘要 -->
            <p class="card-excerpt">
              {{ item.summary }}
            </p>
          </div>
        </div>

        <div v-if="loading && !firstLoading" class="load-more">
          <div class="filmstrip-loading">
            <div class="filmstrip-frame" v-for="n in 3" :key="n" :style="{ animationDelay: `${n * 0.2}s` }"></div>
          </div>
          <span class="loading-text">正在加载更多故事...</span>
        </div>

        <div v-if="noMore && lifeList.length > 0" class="end-section">
          <div class="end-line"></div>
          <div class="end-content">
            <svg class="end-icon" viewBox="0 0 24 24">
              <path
                d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
            </svg>
            <span class="end-text">已展示所有故事</span>
          </div>
          <div class="end-line"></div>
        </div>

        <!-- 用于触发无限滚动的哨兵元素 -->
        <div ref="loadMoreSentinel" class="load-more-sentinel" style="height: 10px; width: 100%;"></div>
      </div>
    </div>
    <BottomTip style="padding-top: 50px" />

    <div v-if="isFullscreen" class="fullscreen-overlay" @click.self="closeFullscreen">
      <div class="fullscreen-content">
        <img :src="currentFullscreenImage" class="fullscreen-image" @click="closeFullscreen" />
      </div>
    </div>

    <div v-if="showLifeComment" class="comment-mask">
      <div class="comments-container mbl-no-hover">
        <div class="cm-title font-color-5">留言板：{{ commLifeTitle }}</div>
        <div class="comment-form">
          <textarea class="bgc font-color-1" v-model="newComment" placeholder="留言内容..." rows="1"></textarea>
          <input class="bgc font-color-1" v-model="newName" placeholder="昵称必填！" style="width: 200px" maxlength="20" />
          <input class="bgc font-color-1" v-model="commEmail" placeholder="邮箱（选填）" style="width: 240px" />
          <button @click="submitComment" class="submit-btn bgc font-color-1">
            发送留言
          </button>
        </div>

        <div class="comments-list" style="color: #ffffff">
          <div v-for="comment in comments" :key="comment.id" class="bgc font-color-1"
            style="border-radius: 10px; margin-bottom: 5px; padding-bottom: 10px">
            <div class="comment-header">
              <img src="@/assets/live2d-photo.png" class="user-avatar" alt="用户头像" />
              <span class="username font-color-1">{{ comment.userName }}</span>
              <span class="comment-time font-color-5">{{
                displayDate(comment.createdTime)
              }}</span>
              <button @click="showReplyBox(comment)" class="reply-btn font-color-1">
                回复
              </button>
            </div>
            <div class="comment-content font-color-5">{{ comment.qsInfo }}</div>

            <div class="replies-info" v-if="comment.replyCount > 0">
              <span class="reply-count ont-color-1" @click="loadReplies(comment)">
                共 {{ comment.replyCount }} 条回复，点击查看
                <span v-if="comment.loadingReplies" class="loading-text font-color-1">加载中...</span>
              </span>
            </div>

            <div v-if="comment.replies && comment.replies.length > 0" class="replies-container">
              <div v-for="reply in comment.replies" :key="reply.id" class="reply-item">
                <div class="reply-header">
                  <img src="@/assets/live2d-photo.png" class="user-avatar" alt="用户头像" />
                  <span class="username">{{ reply.userName }}</span>
                  <span class="reply-time">{{
                    displayDate(reply.createdTime)
                  }}</span>
                  <button @click="showReplyBox(comment, reply)" class="reply-btn font-color-1">
                    回复
                  </button>
                </div>
                <div class="reply-content">
                  {{ reply.qsInfo }}
                </div>
              </div>

              <div v-if="comment.hasMoreReplies" class="load-more-replies">
                <button @click="loadMoreReplies(comment)" class="submit-btn bgc font-color-1">
                  {{ comment.loadingMore ? "加载中..." : "加载更多回复" }}
                </button>
              </div>
            </div>

            <div v-if="activeReplyBox === comment.id" class="reply-box">
              <textarea class="bgc font-color-1" v-model="replyContent" :placeholder="`@${comment.userName} `"
                ref="replyTextarea"></textarea>
              <div class="comment-form">
                <input class="bgc font-color-1" v-model="newName" placeholder="昵称必填" style="width: 200px"
                  maxlength="20" />
                <input class="bgc font-color-1" v-model="commEmail" placeholder="邮箱（选填）" style="width: 240px" />
                <button @click="submitReply(comment)" class="submit-btn bgc font-color-1">
                  回复
                </button>
                <button @click="cancelReply" class="cancel-btn bgc font-color-1">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="loadingComments" class="loading-more font-color-1">
          加载中...
        </div>
        <div v-if="hasMoreComments" class="load-more-hint ont-color-1" @click="loadMoreComments">
          点击加载更多顶级留言
        </div>
        <div v-if="!hasMoreComments && comments.length > 0" class="no-more font-color-1">
          没有更多顶级留言了
        </div>
        <div class="load-more-replies">
          <button class="submit-btn bgc font-color-1" @click="closeLifeComment">
            关闭留言版
          </button>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import SideBar from "@/components/menu/SideBar.vue";
import BottomTip from "@/components/menu/BottomTip.vue";
import TimesView from "@/components/tip/TimesView.vue";
import Weather from "@/components/Weather.vue";
import { mavonEditor } from "mavon-editor";
import "mavon-editor/dist/css/index.css";
import { Message } from "element-ui";

import { getMilestoneList } from "@/api/milestone";
import { getUserInfo } from "@/api/home";
import config from "@/utils/Config";
import {
  getLifeList,
  getArchivesList,
  getLifeListByMonthInfo,
  getLifeTypeListByCount
} from "@/api/life.js";
import { saveCommentsData, getQsList, getRecentQsList } from "@/api/comments";

export default {
  name: "Life",
  components: {
    SideBar,
    BottomTip,
    TimesView,
    Weather,
    mavonEditor,
  },
  data() {
    return {
      showExtraPanel: false,
      showExtraPanelInPC: true,
      typeId: "",
      tags: [],
      colors: [
        "#4ECDC4",
        "#45B7D1",
        "#96CEB4",
        "#FF6B6B",
        "#DDA0DD",
        "#98D8C8",
        "#6C5CE7",
        "#BB8FCE",
        "#85C1E9",
      ],
      baseFileUrl: config.BASE_FILE_URL,
      isFullscreen: false,
      currentFullscreenImage: "",
      screenHeight: document.documentElement.clientHeight + "px",
      archivesList: [],
      lifeList: [],
      lifeTime: "",
      showLifeComment: false,
      defaultCover: "https://liaozhi.site/file/gingercat/default/back-05.png",
      keyword: "",
      fieldName: "",
      pagination: {
        page: 1,
        limit: 6,
        totalSize: 0,
        totalPage: 0,
      },
      loading: false,
      noMore: false,
      firstLoading: true,
      selectMonthValue: "",
      titleList: [],
      currCommentList: [],
      baseImgUrl: config.BASE_FILE_URL,
      milestoneList: [],
      UserInfo: {
        name: "",
        sign: "",
        nameEn: "",
        hometown: "",
        university: "",
        email: "",
      },
      newComment: "",
      newName: "",
      commEmail: "",
      id: -1,
      commLifeId: 0,
      commLifeTitle: "",
      replyContent: "",
      replyEmail: "",
      replyUserName: "",
      comments: [],
      activeReplyBox: null,
      currentReplyTo: null,
      showAllReplies: {},
      currentPage: 1,
      currentSize: 5,
      totalPages: 0,
      loadingComments: false,
      hasMoreComments: true,
      observer: null,
      loadMoreTrigger: null,
      imageObserver: null,
      imageLoadQueue: [],
      activeLoads: 0,
      maxConcurrent: 2,
      typeTimer: null,
      sentinelObserver: null,
      isLoadingMore: false,
    };
  },
  computed: {
    sysConfig() {
      return this.$store?.state?.sysConfig || {};
    },
    currentText() {
      return this.sysConfig.lifeTitle || "🍃此心难凉，此情切切🍃";
    },
  },
  watch: {
    currentText: {
      handler(newText) {
        this.restartTypeWriter();
      },
      immediate: true,
    },
  },
  mounted() {
    const isMobile = /Mobile|Android|iPhone|iPad/i.test(navigator.userAgent);
    const isSmallScreen = window.innerWidth <= 768;
    if (isMobile || isSmallScreen) {
      this.showExtraPanelInPC = false;
    }
    this.initImageObserver();
    this.loadPriorityData().then(() => {
      this.initScrollObserver();
    });
  },
  beforeDestroy() {
    this.stopTypeWriter();
    if (this.imageObserver) this.imageObserver.disconnect();
    if (this.sentinelObserver) this.sentinelObserver.disconnect();
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    stopTypeWriter() {
      if (this.typeTimer) {
        clearTimeout(this.typeTimer);
        this.typeTimer = null;
      }
    },

    resetList() {
      this.lifeList = [];
      this.pagination.page = 1;
      this.pagination.totalPage = 0;
      this.pagination.totalSize = 0;
      this.noMore = false;
      this.firstLoading = false;
      this.isLoadingMore = false;
      this.imageLoadQueue = [];
      this.activeLoads = 0;

      if (this.sentinelObserver) {
        this.sentinelObserver.disconnect();
        this.sentinelObserver = null;
      }
    },

    restartTypeWriter() {
      this.stopTypeWriter();
      const textEl = this.$refs.typeTextEl;
      if (textEl) textEl.textContent = "";
      this.$nextTick(() => {
        this.typeWriter();
      });
    },

    typeWriter() {
      const textEl = this.$refs.typeTextEl;
      if (!textEl) return;
      const text = this.currentText || "";
      const chars = [...text];
      let index = 0;
      let isDeleting = false;
      const type = () => {
        if (!this.typeTimer) return;
        const current = chars.slice(0, index).join("");
        textEl.textContent = current;
        const speed = isDeleting ? 100 : 150;
        if (!isDeleting && index === chars.length) {
          this.typeTimer = setTimeout(() => {
            isDeleting = true;
          }, 2200);
        } else if (isDeleting && index === 0) {
          isDeleting = false;
        } else {
          index += isDeleting ? -1 : 1;
        }
        this.typeTimer = setTimeout(type, speed);
      };
      this.typeTimer = setTimeout(type, 0);
    },

    initImageObserver() {
      this.imageObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const img = entry.target;
              const src = img.getAttribute("data-src");
              if (src && !img.src) {
                this.loadImageWithQueue(img, src);
              }
              this.imageObserver.unobserve(img);
            }
          });
        },
        { root: null, rootMargin: "300px", threshold: 0.01 }
      );
    },

    loadImageWithQueue(imgElement, src) {
      const loadTask = () => {
        this.activeLoads++;
        const tempImg = new Image();
        tempImg.onload = () => {
          imgElement.src = src;
          imgElement.classList.add("loaded");
          const itemId = imgElement.closest(".md-div")?.getAttribute("data-index");
          if (itemId) {
            const item = this.lifeList.find((i) => i.id == itemId);
            if (item) {
              item.imageLoaded = true;
            }
          }
          this.activeLoads--;
          this.processImageQueue();
        };
        tempImg.onerror = () => {
          console.error("图片加载失败:", src);
          this.activeLoads--;
          this.processImageQueue();
        };
        tempImg.src = src;
      };
      if (this.activeLoads >= this.maxConcurrent) {
        this.imageLoadQueue.push(loadTask);
      } else {
        loadTask();
      }
    },

    processImageQueue() {
      if (this.imageLoadQueue.length > 0 && this.activeLoads < this.maxConcurrent) {
        const nextTask = this.imageLoadQueue.shift();
        nextTask();
      }
    },

    observeNewImages() {
      this.$nextTick(() => {
        const images = document.querySelectorAll(".photo-image[data-src]");
        images.forEach((img) => {
          if (!img.src) {
            this.imageObserver.observe(img);
          }
        });
      });
    },

    initScrollObserver() {
      this.$nextTick(() => {
        if (this.sentinelObserver) {
          this.sentinelObserver.disconnect();
          this.sentinelObserver = null;
        }

        const sentinel = this.$refs.loadMoreSentinel;
        if (!sentinel) {
          setTimeout(() => this.initScrollObserver(), 100);
          return;
        }

        this.sentinelObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !this.isLoadingMore && !this.noMore && !this.loading && !this.firstLoading) {
                this.loadMore();
              }
            });
          },
          {
            root: null,
            rootMargin: "0px 0px 100px 0px",
            threshold: 0.01
          }
        );

        this.sentinelObserver.observe(sentinel);
      });
    },

    reattachObserver() {
      if (this.isLoadingMore) {
        setTimeout(() => this.reattachObserver(), 300);
        return;
      }
      this.initScrollObserver();
    },

    async loadMore() {
      if (this.isLoadingMore || this.noMore || this.loading || this.firstLoading) {
        return;
      }

      if (this.pagination.totalPage > 0 && this.pagination.page >= this.pagination.totalPage) {
        this.noMore = true;
        return;
      }

      this.isLoadingMore = true;
      this.loading = true;
      this.pagination.page++;

      try {
        await this.getLifeListInfo(true);
      } catch (error) {
        console.error('加载更多失败:', error);
        this.pagination.page--;
      } finally {
        this.loading = false;
        this.isLoadingMore = false;
        await this.$nextTick();
        this.reattachObserver();
        this.observeNewImages();
      }
    },

    onImageLoad(item) {
      item.imageLoaded = true;
    },

    getRandomColor() {
      const randomIndex = Math.floor(Math.random() * this.colors.length);
      return this.colors[randomIndex];
    },

    displayDate(date) {
      return date ? date.split(" ")[0] : "";
    },

    async loadPriorityData() {
      try {
        await Promise.all([
          this.getLifeListInfo(),
          this.getArchivesListInfo(),
          this.getUserInfo(),
          this.getMilestoneList(),
          this.getRecentQsListInfo(),
          this.getLifeTypeCountInfo(),
        ]);
      } catch (error) {
        console.error("加载关键数据失败:", error);
      }
      this.firstLoading = false;
      this.observeNewImages();
      this.initScrollObserver();
    },

    getFirstMediaFromContent(content) {
      if (!content) return { type: "default", url: this.defaultCover };
      const videoRegex = /<video.*?src=["'](.*?)["']/i;
      const videoMatch = content.match(videoRegex);
      if (videoMatch && videoMatch[1]) {
        let url = videoMatch[1].trim();
        if (url.startsWith("/") || url.startsWith("./") || url.startsWith("../")) {
          url = this.baseFileUrl + url.replace(/^(\.\/|\.\.\/)/, "");
        }
        return { type: "video", url: url };
      }
      const imgRegex = /!\[.*?\]\(([^)]+)\)/;
      const imgMatch = content.match(imgRegex);
      if (imgMatch && imgMatch[1]) {
        let url = imgMatch[1].trim();
        if (url.startsWith("/") || url.startsWith("./") || url.startsWith("../")) {
          url = this.baseFileUrl + url.replace(/^(\.\/|\.\.\/)/, "");
        }
        return { type: "image", url: url };
      }
      const htmlImgRegex = /<img.*?src=["'](.*?)["']/i;
      const htmlImgMatch = content.match(htmlImgRegex);
      if (htmlImgMatch && htmlImgMatch[1]) {
        let url = htmlImgMatch[1].trim();
        if (url.startsWith("/") || url.startsWith("./") || url.startsWith("../")) {
          url = this.baseFileUrl + url.replace(/^(\.\/|\.\.\/)/, "");
        }
        return { type: "image", url: url };
      }
      return { type: "default", url: this.defaultCover };
    },

    getMarkdownSummary(markdown, length = 30) {
      if (!markdown) return "暂无内容";
      let text = markdown.replace(/```[\s\S]*?```/g, "");
      text = text.replace(/`.*?`/g, "");
      text = text.replace(/!\[.*?\]\(.*?\)/g, "");
      text = text.replace(/\[(.*?)\]\(.*?\)/g, "$1");
      text = text.replace(/^#{1,6}\s+/gm, "");
      text = text.replace(/(\*\*|__)(.*?)\1/g, "$2");
      text = text.replace(/(\*|_)(.*?)\1/g, "$2");
      text = text.replace(/~~(.*?)~~/g, "$1");
      text = text.replace(/<[^>]*>/g, "");
      text = text.replace(/^\s*>\s+/gm, "");
      text = text.replace(/^\s*[-*+]\s+/gm, "");
      text = text.replace(/^\s*\d+\.\s+/gm, "");
      text = text.replace(/^[-*_]{3,}$/gm, "");
      text = text.replace(/\s+/g, " ").trim();
      return text.length > length ? text.substring(0, length) + "..." : text;
    },

    async loadMoreReplies(comment) {
      if (comment.loadingMore) return;
      comment.loadingMore = true;
      try {
        const nextPage = comment.replyPage + 1;
        const resp = await getQsList({
          lifeId: this.commLifeId,
          id: comment.id,
          pageNo: nextPage,
          pageSize: this.currentSize,
        });
        if (resp.code === 200) {
          const newReplies = resp.data.data || [];
          comment.replies = [...comment.replies, ...newReplies];
          comment.replyPage = nextPage;
          comment.hasMoreReplies = comment.replies.length < comment.replyCount;
        } else {
          Message.error(resp.msg || "加载更多回复失败");
        }
      } catch (error) {
        Message.error("网络错误，请稍后重试");
      } finally {
        comment.loadingMore = false;
      }
    },

    goToDetail(id) {
      this.$router.push({ path: "/life-detail", query: { id: id } });
    },

    async loadReplies(comment) {
      if (comment.loadingReplies || comment.replies.length > 0) return;
      comment.loadingReplies = true;
      try {
        const resp = await getQsList({
          lifeId: this.commLifeId,
          id: comment.id,
          pageNo: 1,
          pageSize: this.currentSize,
        });
        if (resp.code === 200) {
          comment.replies = resp.data.data || [];
          comment.replyPage = 1;
          comment.hasMoreReplies = comment.replies.length >= this.currentSize && comment.replies.length < comment.replyCount;
        } else {
          Message.error(resp.msg || "加载回复失败");
        }
      } catch (error) {
        Message.error("网络错误，请稍后重试");
      } finally {
        comment.loadingReplies = false;
      }
    },

    async loadMoreComments() {
      if (this.currentPage >= this.totalPages) {
        this.hasMoreComments = false;
        return;
      }
      if (this.loadingComments) return;
      this.loadingComments = true;
      this.currentPage++;
      try {
        const resp = await getQsList({
          id: this.id,
          lifeId: this.commLifeId,
          pageNo: this.currentPage,
          pageSize: this.currentSize,
        });
        if (resp.code === 200) {
          const newComments = resp.data.data || [];
          newComments.forEach((comment) => {
            comment.replies = [];
            comment.replyPage = 1;
            comment.hasMoreReplies = false;
            comment.loadingReplies = false;
            comment.loadingMore = false;
          });
          this.comments = [...this.comments, ...newComments];
          if (this.currentPage >= resp.data.totalPage) {
            this.hasMoreComments = false;
          }
        } else {
          Message.error(resp.msg || "加载更多失败");
          this.currentPage--;
        }
      } catch (error) {
        Message.error("网络错误，请稍后重试");
        this.currentPage--;
      } finally {
        this.loadingComments = false;
      }
    },

    async openLifeComment(id, title) {
      this.commLifeId = id;
      this.commLifeTitle = title;
      await this.getQsListInfo();
      this.showLifeComment = !this.showLifeComment;
      document.body.style.overflow = "hidden";
    },

    async getRecentQsListInfo() {
      try {
        const resp = await getRecentQsList();
        if (resp != null && resp.code == 200) {
          this.currCommentList = resp.data;
        }
      } catch (error) {
        Message.error("获取最新留言失败！");
      }
    },

    async getLifeTypeCountInfo() {
      try {
        const resp = await getLifeTypeListByCount();
        if (resp != null && resp.code == 200) {
          this.tags = resp.data;
        }
      } catch (error) {
        Message.error("加载故事归档失败！");
      }
    },

    closeLifeComment() {
      this.showLifeComment = !this.showLifeComment;
      document.body.style.overflow = "";
    },

    closeFullscreen() {
      this.isFullscreen = false;
      document.body.style.overflow = "";
    },

    async handleToSelectItem(value) {
      await this.handleToSelectMonth();
      if (this.lifeTime == "") {
        return;
      }
      const info = this.lifeTime.split("(")[0].split("-");
      const year = info[0];
      const month = info[1];
      var yearMonth = `${year}-${month}`;
      await this.searchListByTime(yearMonth);
    },

    async searchListByType(value) {
      this.resetList();
      this.keyword = value;
      this.fieldName = "typeId";
      const SearchQo = {
        pageNo: 1,
        pageSize: this.pagination.limit,
        fieldName: this.fieldName,
        keyword: this.keyword,
      };
      const resp = await getLifeList(SearchQo);
      if (resp.data != null) {
        this.lifeList = this.processLifeList(resp.data.data);
        this.pagination.totalSize = resp.data.totalSize;
        this.pagination.totalPage = resp.data.totalPage;
        this.noMore = this.pagination.page >= this.pagination.totalPage;
      }
      await this.$nextTick();
      this.observeNewImages();
      this.initScrollObserver();
    },

    async searchListByTime(value) {
      this.resetList();
      this.keyword = value;
      this.fieldName = "createdTime";
      const SearchQo = {
        pageNo: 1,
        pageSize: this.pagination.limit,
        fieldName: this.fieldName,
        keyword: this.keyword,
      };
      const resp = await getLifeList(SearchQo);
      if (resp.data != null) {
        this.lifeList = this.processLifeList(resp.data.data);
        this.pagination.totalSize = resp.data.totalSize;
        this.pagination.totalPage = resp.data.totalPage;
        this.noMore = this.pagination.page >= this.pagination.totalPage;
      }
      await this.$nextTick();
      this.observeNewImages();
      this.initScrollObserver();
    },

    async searchListByKeyword(value, fieldNameType) {
      this.resetList();
      this.keyword = value;
      this.fieldName = fieldNameType;
      const SearchQo = {
        pageNo: 1,
        pageSize: this.pagination.limit,
        fieldName: this.fieldName,
        keyword: this.keyword,
      };

      const resp = await getLifeList(SearchQo);
      if (resp.data != null) {
        this.lifeList = this.processLifeList(resp.data.data);
        this.pagination.totalSize = resp.data.totalSize;
        this.pagination.totalPage = resp.data.totalPage;
        this.noMore = this.pagination.page >= this.pagination.totalPage;
      }
      await this.$nextTick();
      this.observeNewImages();
      this.firstLoading = false;
      this.initScrollObserver();
    },

    async handleToSelectMonth() {
      if (this.lifeTime == "") {
        return;
      }
      const info = this.lifeTime.split("(")[0].split("-");
      const year = info[0];
      const month = info[1];
      var yearMonth = `${year}-${month}`;
      const resp = await getLifeListByMonthInfo({ date: yearMonth });
      if (resp.data != null) {
        this.titleList = resp.data;
      }
    },

    async getArchivesListInfo() {
      const resp = await getArchivesList({});
      if (resp.data != null) {
        this.archivesList = resp.data;
      }
      if (this.archivesList != [] && this.archivesList.length != 0) {
        this.lifeTime = this.archivesList[0].value;
      }
      await this.handleToSelectMonth();
    },

    processLifeList(list) {
      if (!list) return [];
      return list.map((item) => ({
        ...item,
        lqip: this.generateLQIP(item.content),
        imageLoaded: false,
      }));
    },

    generateLQIP(content) {
      return this.defaultCover;
    },

    async getLifeListInfo(append = false) {
      if (this.noMore && append) return;
      const SearchQo = {
        pageNo: this.pagination.page,
        pageSize: this.pagination.limit,
        keyword: this.keyword,
        fieldName: this.fieldName,
      };
      const resp = await getLifeList(SearchQo);
      if (resp.data != null) {
        const data = this.processLifeList(resp.data.data);
        if (append) {
          this.lifeList = [...this.lifeList, ...data];
        } else {
          this.lifeList = data;
        }
        this.pagination.totalSize = resp.data.totalSize;
        this.pagination.totalPage = resp.data.totalPage;
        this.noMore = this.pagination.page >= this.pagination.totalPage;
      }
    },

    async getMilestoneList() {
      const resp = await getMilestoneList({});
      if (resp.data != null) {
        this.milestoneList = resp.data;
      }
    },

    async getUserInfo() {
      const resp = await getUserInfo({ id: config.BASE_USER_ID });
      this.UserInfo = resp.data;
      this.UserInfo.portrait = config.BASE_FILE_URL + resp.data.portrait;
      this.UserInfo.draw = config.BASE_FILE_URL + resp.data.draw;
      return resp;
    },

    async getQsListInfo() {
      if (this.loadingComments) return;
      this.loadingComments = true;
      try {
        const resp = await getQsList({
          id: this.id,
          lifeId: this.commLifeId,
          pageNo: 1,
          pageSize: this.currentSize,
        });
        if (resp.code === 200) {
          this.currentPage = 1;
          this.comments = resp.data.data || [];
          this.totalPages = resp.data.totalPage || 1;
          this.comments.forEach((comment) => {
            comment.replies = [];
            comment.replyPage = 1;
            comment.hasMoreReplies = comment.replyCount > 0;
            comment.loadingReplies = false;
            comment.loadingMore = false;
          });
          this.hasMoreComments = this.currentPage < this.totalPages;
        } else {
          Message.error(resp.msg || "获取留言列表失败，请稍后重试");
        }
      } catch (error) {
        Message.error("网络错误，请稍后重试");
      } finally {
        this.loadingComments = false;
      }
    },

    async submitComment() {
      if (this.newComment.trim() === "") {
        Message.error("请输入留言内容");
        return;
      }
      if (this.newName.trim() === "") {
        Message.error("请输入昵称");
        return;
      }
      const newComment = {
        parentId: null,
        lifeId: this.commLifeId,
        email: this.commEmail,
        userName: this.newName,
        qsInfo: this.newComment,
      };
      saveCommentsData(newComment)
        .then((resp) => {
          if (resp.code === 200) {
            Message.success("操作成功，感谢您的留言！");
            this.newComment = "";
            this.getQsListInfo();
          } else {
            Message.error(resp.msg || "留言失败，请稍后重试");
          }
        })
        .catch(() => {
          Message.error("网络错误，请稍后重试");
        });
    },

    showReplyBox(comment, reply = null) {
      this.activeReplyBox = comment.id;
      this.currentReplyTo = reply ? reply.userName : comment.userName;
      this.replyContent = `@${this.currentReplyTo} `;
      this.replyEmail = this.commEmail;
      this.$nextTick(() => {
        if (this.$refs.replyTextarea) {
          this.$refs.replyTextarea.focus();
        }
      });
    },

    submitReply(comment) {
      if (this.replyContent.trim() === "") {
        Message.error("请输入回复内容");
        return;
      }
      if (this.newName.trim() === "") {
        Message.error("请输入昵称");
        return;
      }
      const newReply = {
        parentId: comment.id,
        lifeId: this.commLifeId,
        userName: this.newName,
        email: this.commEmail,
        qsInfo: this.replyContent,
      };
      saveCommentsData(newReply)
        .then((resp) => {
          if (resp.code === 200) {
            Message.success("回复成功！");
            this.replyContent = "";
            this.activeReplyBox = null;
            this.currentReplyTo = null;
            this.getQsListInfo();
          } else {
            Message.error(resp.msg || "回复失败，请稍后重试");
          }
        })
        .catch(() => {
          Message.error("网络错误，请稍后重试");
        });
    },

    cancelReply() {
      this.activeReplyBox = null;
      this.currentReplyTo = null;
      this.replyContent = "";
    },
  },
};
</script>

<style scoped>
.home-div {
  width: 100%;
  min-height: 100vh;
  padding-top: 60px;
  overflow: hidden;
}

.content {
  margin: 0 auto;
  padding: 0 120px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 20px;
}

.announcement {
  width: 100%;
  padding: 22px 0;
  border: 2px dashed #f7f4f4;
  border-radius: 10px;
  display: flex;
  font-size: 20px;
  margin: 0 auto 10px;
}

.left {
  flex: 3;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 电脑端三列网格布局 - 新增样式 */
@media only screen and (min-width: 769px) {
  .info {
    display: grid !important;
    grid-template-columns: repeat(3, 1fr) !important;
    gap: 10px !important;
  }

  .info .md-div {
    display: flex !important;
    flex-direction: column !important;
    margin-bottom: 10px;
  }

  .info .md-div .md-img-info {
    width: 100% !important;
    height: auto !important;
    aspect-ratio: 4 / 3 !important;
    margin-bottom: 12px !important;
  }

  .info .md-div .md-title {
    order: 1 !important;
    padding: 8px 12px 0 0 !important;
    font-size: 18px !important;
  }

  .info .md-div .con-info {
    order: 2 !important;
    margin-top: 8px !important;
    padding: 0 !important;
    border-top: none !important;
  }

  .info .md-div .card-excerpt {
    order: 3 !important;
  }

  .info .md-div>div:first-child {
    flex-direction: column !important;
  }
}

/* 平板：两列 */
@media only screen and (min-width: 769px) and (max-width: 1024px) {
  .info {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

.md-div {
  color: var(--font-color-1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  background-color: rgba(255, 250, 240, 0.7);
  backdrop-filter: blur(16px) saturate(180%);
  will-change: transform;
  opacity: 0;
  transform: translateY(20px);
  animation: card-appear 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  content-visibility: auto;
  contain-intrinsic-size: 300px;
  padding: 10px 10px 0 10px;
  box-shadow:
    7px 7px 10px rgba(0, 0, 0, .9),
    -5px -5px 10px rgba(239, 235, 235, 0.3);

  /* 合并 transition，不要重复定义 */
  transition: opacity 0.3s ease,
    transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1),
    box-shadow 0.4s ease,
    background 0.3s ease,
    border-color 0.3s ease,
    color 0.3s ease;
}

/* 鼠标悬停时的发光浮动效果 */
.md-div:hover {
  color: var(--font-color-5);
  background: rgba(255, 255, 255, 0.12);
  box-shadow: 0 0 30px 10px rgba(255, 255, 255, 0.3),
    0 0 60px 20px rgba(100, 180, 255, 0.2);
  transform: translateY(-6px) scale(1.03);
  /* 增加浮动距离和放大倍数 */
  border-color: rgba(255, 255, 255, 0.4);
}

/* 可选：深色模式优化 */
@media (prefers-color-scheme: dark) {
  .md-div:hover {
    background: rgba(255, 255, 255, 0.08);
    box-shadow: 0 0 35px 12px rgba(120, 200, 255, 0.2),
      0 0 70px 25px rgba(80, 150, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.3);
  }
}


.md-img-info {
  width: 360px;
  height: 200px;
  overflow: hidden;
  flex-shrink: 0;
  background: #111;
  border-radius: 8px;
  /* 可选，增加圆角更美观 */
}

.md-img-info img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  display: block;
}

.md-img-info:hover img {
  transform: scale(1.12);
}

.md-text-box {
  flex: 1;
  padding-left: 16px;
}

.top-title {
  font-size: 28px;
  font-weight: 500;
  margin: 30px auto;
  letter-spacing: 2px;
  text-align: center;
  height: 40px;
}

@keyframes card-appear {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.md-div:hover {
  transform: translateY(-6px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4), 0 0 25px rgba(255, 255, 255, 0.35);
}

.md-title {
  font-size: 20px;
  font-weight: 700;
  padding: 0 0 10px 0;
}

.card-excerpt {
  text-indent: 2em;
  font-size: 12px;
  margin-top: 10px;
  font-style: italic;
}

.md-img-div {
  display: flex;
  gap: 10px;
  font-size: 12px;
  padding-top: 6px;
}

.con-info {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 10px;
}

.md-img-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

.md-img {
  width: 18px;
  height: 18px;
}

.info {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 10px;
  width: 100%;
}

.art-skeleton {
  padding: 1rem 0;
}

.skeleton-container {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 24px;
}

.skeleton-card {
  animation: skeleton-pulse 1.5s ease-in-out infinite;
}

@keyframes skeleton-pulse {

  0%,
  100% {
    opacity: 0.6;
  }

  50% {
    opacity: 0.3;
  }
}

.skeleton-image {
  width: 100%;
  aspect-ratio: 4/3;
  background: linear-gradient(90deg, rgba(30, 41, 59, 0.6) 25%, rgba(51, 65, 85, 0.8) 50%, rgba(30, 41, 59, 0.6) 75%);
  background-size: 200% 100%;
  border-radius: 10px;
  margin-bottom: 1rem;
  animation: skeleton-wave 2s ease-in-out infinite;
}

.card-line {
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  order: 3;
  height: 1px;
  margin-top: 6px;
}

.skeleton-info {
  padding: 0.5rem;
}

.skeleton-line {
  height: 16px;
  background: rgba(30, 41, 59, 0.8);
  border-radius: 4px;
  margin-bottom: 8px;
}

.skeleton-line.short {
  width: 60%;
}

.skeleton-line.small {
  width: 40%;
  height: 12px;
}

@keyframes skeleton-wave {
  0% {
    background-position: -200% 0;
  }

  100% {
    background-position: 200% 0;
  }
}

.progressive-layer {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.image-blur-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  filter: blur(0px);
  opacity: 0.1;
  z-index: 1;
}

.photo-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  opacity: 0;
  transition: opacity 0.4s ease;
  /* image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges; */
  object-fit: cover;
  object-position: center;
}

.photo-image.loaded {
  opacity: 1;
}

.loading-state {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
}

.loading-circle {
  width: 40px;
  height: 40px;
  position: relative;
}

.loading-inner {
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-top-color: #60a5fa;
  border-right-color: #60a5fa;
  border-radius: 50%;
  animation: loading-rotate 0.8s linear infinite;
}

@keyframes loading-rotate {
  to {
    transform: rotate(360deg);
  }
}

.load-more {
  text-align: center;
  padding: 2rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.filmstrip-loading {
  display: flex;
  gap: 8px;
}

.filmstrip-frame {
  width: 40px;
  height: 50px;
  background: linear-gradient(135deg, #1e293b, #334155);
  border-radius: 4px;
  animation: filmstrip-move 1.5s ease-in-out infinite;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

@keyframes filmstrip-move {

  0%,
  100% {
    transform: translateY(0);
    opacity: 0.6;
  }

  50% {
    transform: translateY(-10px);
    opacity: 1;
  }
}

.loading-text {
  font-size: 0.9rem;
  color: #94a3b8;
  letter-spacing: 1px;
}

.end-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  padding: 3rem 0;
}

.end-line {
  width: 80px;
  height: 1px;
  background: linear-gradient(to right, transparent, #47569, transparent);
}

.end-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.end-icon {
  width: 24px;
  height: 24px;
  fill: #64748b;
}

.end-text {
  font-size: 0.9rem;
  color: #94a3b8;
  letter-spacing: 1px;
}

.ls-div {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.rg-title-1 {
  margin: 10px 0 10px 0;
  font-size: 18px;
  text-align: center;

  color: #86b3e0;
  background: linear-gradient(90deg, #ff0080, #ff8c00, #40e0d0, #9370db, #ff0080);
  background-size: 400% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradientMove 8s ease-in-out infinite;
}

@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.tag-style {
  content: " ";
  position: absolute;
  border-radius: 10px;
  background: #fc625d;
  width: 10px;
  height: 10px;
  box-shadow: 20px 0 #fdbc40, 40px 0 #35cd4b;
  float: right;
  right: 55px;
  top: 20px;
}

.book-icon {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.book-icon-con {
  display: flex;
  align-items: center;
  justify-items: center;

  color: #2c3e50;
  background: linear-gradient(90deg, #ff0080, #ff8c00, #40e0d0, #9370db, #ff0080);
  background-size: 400% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradientMove 8s ease-in-out infinite;
}

@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.tag-icon-con {
  display: flex;
  align-items: center;
  justify-items: center;
}

.tag-icon {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}

.tag-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border-radius: 10px;
}

.tag-container::after {
  content: "";
  flex: 1;
  min-width: calc(25% - 10px);
}

.ls-title {
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 8px;
}

.ls-line {
  width: 50px;
  height: 3px;
  background: rgb(115, 210, 67);
  border-radius: 2px;
  margin-bottom: 12px;
}

.tag {
  padding: 5px;
  border-radius: 5px;
  color: var(--font-color-1);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.tag:hover {
  background: linear-gradient(135deg, #ff0000, #ff6b6b) !important;
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);
}

.li-title {
  padding: 5px 0;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
}

.li-title:hover {
  padding-left: 6px;
  font-weight: 600;
}

.infinite-list {
  max-height: 220px;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  list-style: none;
}

.infinite-list::-webkit-scrollbar {
  width: 6px;
}

.infinite-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
}

.comment-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.comments-container {
  width: 90%;
  max-width: 800px;
  max-height: 85vh;
  background: rgba(10, 10, 15, 0.92);
  backdrop-filter: blur(30px);
  border-radius: 10px;
  padding: 20px;
  overflow-y: auto;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.cm-title {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 16px;
}

.bgc {
  background: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  color: #5c4e3a !important;
}

.bgc::placeholder {
  color: #ccc !important;
}

.fullscreen-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9998;
}

.fullscreen-image {
  max-width: 90%;
  max-height: 90vh;
  object-fit: contain;
}

.back-top-btn:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: scale(1.1);
}

.top-icon {
  font-size: 24px;
  font-weight: bold;
}

@media only screen and (max-width: 1200px) {
  .content {
    padding: 0 60px;
  }

  .info,
  .skeleton-container {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media only screen and (max-width: 768px) {
  .content {
    padding: 0 20px;
    flex-direction: column;
  }

  .announcement {
    font-size: 18px;
  }

  .left,
  .right {
    width: 100%;
  }

  .info,
  .skeleton-container {
    grid-template-columns: 1fr;
  }

  .comments-container {
    width: 95%;
  }

  .top-title {
    font-size: 24px;
    margin: 20px auto;
  }

  /* 手机端：上图下文 */
  .md-div>div:first-child {
    flex-direction: column !important;
  }

  .md-img-info {
    width: 100% !important;
    height: 220px !important;
    margin-bottom: 12px;
  }

  .md-text-box {
    padding-left: 0 !important;
  }

  .mobile-collapse-btn {
    display: block;
    background: rgba(255, 255, 255, 0.1);
    text-align: center;
    padding: 10px 0;
    border-radius: 10px;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  .extra-panel {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.6s ease;
  }

  .extra-panel.open {
    max-height: 2000px;
  }
}

.thumb {
  border-radius: 2px;

  /* ✅ 超轻微幅度 · 自然毛笔刷边缘（永不裁切内容） */
  clip-path: polygon(0% 1.0%,
      1% 0%,
      3% 1.2%,
      6% 0.2%,
      9% 1.1%,
      12% 0.3%,
      15% 1.0%,
      18% 0.2%,
      22% 1.1%,
      25% 0.3%,
      28% 1.0%,
      32% 0.2%,
      35% 1.2%,
      38% 0.3%,
      42% 1.0%,
      45% 0.2%,
      48% 1.1%,
      52% 0.3%,
      55% 1.0%,
      58% 0.2%,
      62% 1.2%,
      65% 0.3%,
      68% 1.0%,
      72% 0.2%,
      75% 1.1%,
      78% 0.3%,
      82% 1.0%,
      85% 0.2%,
      88% 1.2%,
      92% 0.3%,
      95% 1.0%,
      98% 0.2%,
      100% 1.0%,

      100% 99.0%,
      98% 100%,
      95% 98.8%,
      92% 99.8%,
      88% 98.9%,
      85% 99.7%,
      82% 99.0%,
      78% 99.8%,
      75% 98.9%,
      72% 99.7%,
      68% 99.0%,
      65% 99.8%,
      62% 98.8%,
      58% 99.7%,
      55% 99.0%,
      52% 99.8%,
      48% 98.9%,
      45% 99.7%,
      42% 99.0%,
      38% 99.8%,
      35% 98.8%,
      32% 99.7%,
      28% 99.0%,
      25% 99.8%,
      22% 98.9%,
      18% 99.7%,
      15% 99.0%,
      12% 99.8%,
      9% 98.8%,
      6% 99.7%,
      3% 99.0%,
      1% 99.8%,
      0% 99.0%);
}

.type-text {
  font-weight: 500;
  /* color: var(--font-color-5); */
  color: #2c3e50;
  background: linear-gradient(90deg, #ff0080, #ff8c00, #40e0d0, #9370db, #ff0080);
  background-size: 400% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradientMove 8s ease-in-out infinite;
}

.cursor {
  margin-left: 2px;
  color: var(--font-color-5);
  animation: blink 1.2s infinite;
}

@keyframes blink {

  0%,
  50% {
    opacity: 1;
  }

  51%,
  100% {
    opacity: 0;
  }
}

.el-icon-loading {
  animation: rotating 1s linear infinite;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>